export default "__VITE_ASSET__b3ThRkXU__"